import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme) => ({
  pageContainer: {
    paddingTop: '120px', // Ajuste este valor conforme necessário
    paddingBottom: theme.spacing(4),
    minHeight: 'calc(100vh - 120px)', // Ajuste para altura total menos o header
  },
  root: {
    padding: theme.spacing(4),
   
  },
  paper: {
    padding: theme.spacing(4),
    borderRadius: theme.spacing(2),
     marginTop: theme.spacing(18),
  },
  icon: {
    marginRight: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  pdfViewer: {
    width: '100%',
    height: '500px',
    border: 'none',
    marginTop: theme.spacing(6),
  },
  form: {
    marginTop: theme.spacing(3),
  },
  passwordInput: {
    flex: 1,
    padding: theme.spacing(1.5),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    fontSize: '1rem',
    marginLeft: theme.spacing(1),
    '&:focus': {
      outline: 'none',
      borderColor: theme.palette.primary.main,
    },
  },
  lockIcon: {
    color: theme.palette.text.secondary,
  },
  submitButton: {
    padding: theme.spacing(1.5),
    fontSize: '1rem',
  },
  error: {
    marginTop: theme.spacing(1),
  },
}));